export default {
  path: '',
  component: () => import(`@/page/distributor/component/basic-layout/1.0.4/index.vue`),
  children: [
    {
      path: '/distributor/train/back',
      component: () => import('@/page/distributor/component/admin-layout/index.vue'),
      children: [
        {
          path: '/distributor/train/back/train-contend-detail',
          name: 'distributor-train-back-train-contend-detail',
          component: () => import('@/page/distributor/train/back/train-contend-detail/index.vue'),
          meta: {
            nav_list_for_admin_layout_head_nav: [
              {name: `管理后台`},
              {name: `订单管理`},
              {name: `火车票`},
              {name: `抢票详情`},
            ],
          },
        },
      ]
    },
  ]
};
